<app-capital-container>
    <app-capital-back />

    <div class="certificates-content">
        <h1 class="certificates-title">¿ NECESITAS UN CERTIFICADO ?</h1>
        <p class="certificates-subtitle">Selecciona el certificado que necesitas</p>

        @for (categoria of categorias(); track categoria) {
        <div class="categoria-section">
            <h2 class="categoria-title">{{ categoria }}</h2>

            <div class="row gx-3 gy-4 align-items-stretch">
                @for (item of certificadosPorCategoria()[categoria]; track item.index) {
                <div class="col-12 col-md-6 col-lg-4">
                    <app-capital-card shadow="normal" (click)="selectCertificado(item.path)">
                        <div class="certificate-card-button">
                            <h3 class="certificate-name">{{ item.name }}</h3>
                            <p class="certificate-description">{{ item.description }}</p>
                        </div>
                    </app-capital-card>
                </div>
                }
            </div>
        </div>
        }
    </div>
</app-capital-container>